import {ButtonGroup, Button} from "@progress/kendo-react-buttons"
import React from "react"

export type WeekDays = {
    name: string
    value: string
}


export const allWeekDays: WeekDays[] = [
    {
        name: "SUN",
        value: "SUN",
    },
    {
        name: "MON",
        value: "MON",
    },
    {
        name: "TUE",
        value: "TUE",
    },
    {
        name: "WED",
        value: "WED",
    },
    {
        name: "THU",
        value: "THU",
    },
    {
        name: "FRI",
        value: "FRI",
    },
    {
        name: "SAT",
        value: "SAT",
    },
]

const WeekDaysComponent = ({
    repeatDays,
    handleRepeatDays,
    startDate,
}: {
    repeatDays: string[]
    handleRepeatDays: (value: string) => void
    startDate: Date
}) => {
    return (
        <ButtonGroup>
            {allWeekDays.map((week, index) => {
                return (
                    <Button
                        togglable={true}
                        onClick={() => handleRepeatDays(week.value)}
                        selected={repeatDays.includes(week.value)}
                        key={index}
                        type="button"
                        disabled={allWeekDays[startDate.getDay()] === week}
                    >
                        {week.name}
                    </Button>
                )
            })}
        </ButtonGroup>
    )
}
export default React.memo(WeekDaysComponent)
